import parse from 'html-react-parser'
import { useMemo } from 'react'
import { MENTION_REGEX } from '@omnea-app/fe-comments/CommentStringWithMentions'
import { removeNewLinesFromEnd } from '@omnea-app/fe-rich-text/utils'

export const CommentEmptyMessageWithConfiguredText = ({ emptyCommentsMessage }: { emptyCommentsMessage: string }) => {
  return useMemo(() => {
    if (!emptyCommentsMessage) return undefined

    const htmlWithStyledMentions = styleMentions(emptyCommentsMessage)
    const trimmedValue = removeNewLinesFromEnd(htmlWithStyledMentions)

    return parse(trimmedValue, {
      replace: (node) => {
        // strip off any style tags that might make the comment unreadable
        if ('attribs' in node && node.attribs && node.attribs.style) {
          delete node.attribs.style
        }
      },
    })
  }, [emptyCommentsMessage])
}

const styleMentions = (comment: string) => {
  const result = comment.replace(MENTION_REGEX, (_, name) => `<strong>${name}</strong>`)
  return result
}
